export default __webpack_public_path__ + "static/media/html-logo.a577af37.png";